"use client";

import { env } from "@/env.mjs";
import {
  getAnalyticsCookie,
  useAnalyticsState,
} from "@/utils/hooks/use-analytics-state";
import { useEffect, useState } from "react";

export default function Sentry() {
  const { analyticsCookie } = useAnalyticsState();
  const [didLoadSentry, setDidLoadSentry] = useState(false);

  useEffect(() => {
    if (analyticsCookie?.isSentryOn && !didLoadSentry) {
      initSentry();
      setDidLoadSentry(true);
    } else if (!analyticsCookie?.isSentryOn && didLoadSentry) {
      removeSentry();
      setDidLoadSentry(false);
    }
  }, [analyticsCookie, didLoadSentry]);
  return null;
}

async function initSentry() {
  const { init, replayIntegration, getClient } = await import("@sentry/nextjs");
  // Sentry mag es nicht wenn init mehr als ein mal ausgeführt wird
  if (
    typeof replayIntegration !== "undefined" &&
    typeof init !== "undefined" &&
    getClient() === undefined
  ) {
    init({
      release: env.NEXT_PUBLIC_APP_VERSION,
      // Adds request headers and IP for users, for more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
      sendDefaultPii: false,
      beforeSend(event) {
        const isSentryOn: boolean = getAnalyticsCookie()?.isSentryOn ?? false;
        delete event.user?.ip_address;
        delete event.contexts?.device;
        delete event.contexts?.os;
        if (event.contexts && event.contexts.app) {
          event.contexts.app.app_version = env.NEXT_PUBLIC_APP_VERSION;
        }
        if (isSentryOn) {
          return event;
        } else {
          return null;
        }
      },
      dsn: "https://20f9232e6e0afc6e84d505317d79628a@o4505748191969280.ingest.sentry.io/4505884988211200",
      integrations: [replayIntegration()],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
}

async function removeSentry(): Promise<void> {
  const { close, getClient } = await import("@sentry/nextjs");
  if (getClient() !== undefined) {
    if (close && typeof close !== "undefined") {
      await close(2000);
    }
  }
}
